export const MOODS=[
  ['Focus mode','ambient','Less noise. More flow.','eclipse'],
  ['Slow mornings','chill','Ease into your day.','sunrise'],
  ['After hours','electronic','Stay a little longer.','city'],
  ['The jazz corner','jazz','Good company, great jazz.','jazz'],
  ['Feel-good favorites','pop','A brighter kind of day.','sunrise'],
  ['Deep work','instrumental','Find your concentration.','eclipse'],
  ['Open-road radio','rock','A soundtrack for the miles.','drive'],
  ['Golden oldies','oldies','The songs that stay with you.','mountains'],
  ['Coffeehouse calm','acoustic','Settle in, take a sip.','sunrise'],
  ['Dance-floor energy','dance','Turn the room up.','city'],
  ['Calm waters','relaxation','Take a softer breath.','mountains'],
  ['Classical escape','classical','A little room for wonder.','eclipse'],
  ['Soul session','soul','Warm voices, deeper feelings.','jazz'],
  ['The blues hour','blues','Let the feeling linger.','jazz'],
  ['Indie discoveries','indie','Meet your next favorite.','mountains'],
  ['Back to the 80s','80s','Neon memories, timeless hooks.','city'],
  ['The 90s rewind','90s','A familiar kind of freedom.','drive'],
  ['Cozy evenings','lounge','Let the day slow down.','sunrise'],
  ['Sleep soundly','sleep','Drift a little further.','eclipse'],
  ['A nature break','nature','Bring the outside closer.','mountains'],
  ['Workout boost','workout','Find a little extra energy.','drive'],
  ['Latin sunshine','latin','A warmer rhythm awaits.','sunrise'],
  ['Reggae state of mind','reggae','Easy rhythms, lighter days.','mountains'],
  ['Country roads','country','Stories from the open road.','drive'],
  ['Heavy rotation','metal','Make some room for loud.','city'],
  ['Lo-fi loop','lofi','Low-key sounds for your day.','eclipse'],
  ['House party','house','Keep the good energy going.','city'],
  ['Techno nights','techno','Find your pulse after dark.','city'],
  ['Trance horizons','trance','Go a little beyond.','eclipse'],
  ['Hip-hop hour','hip hop','Stories, beats and attitude.','drive'],
  ['Fresh perspectives','news','Tune into the wider world.','mountains'],
  ['Let’s talk','talk','Good conversations live here.','jazz'],
  ['World explorer','world','A new place in every song.','mountains'],
  ['Folk stories','folk','Something honest, something human.','sunrise'],
  ['Cinema sounds','soundtrack','Give your day a bigger score.','eclipse'],
  ['Disco fever','disco','Make a little room to move.','city'],
].map(([name,tag,caption,art])=>({name,tag,caption,art,artwork:`/art/moods/${tag.replaceAll(' ','-')}.webp`}));
